export enum MessageType {
  API_CALL = "supernova-api-call",
  API_RESPONSE = "supernova-api-response",
  STATUS = "supernova-status-message",
  EVENT = "supernova-event",
}

export interface APICallPayload {
  method: string;
  args: any[];
  type: MessageType.API_CALL;
  uuid: string;
}

export interface APIResponsePayload {
  type: MessageType.API_RESPONSE;
  result: supernova.external.ApiResult;
  uuid: string;
}

export interface StatusPayload {
  isReady: boolean;
  applicationName: string;
  type: MessageType.STATUS;
}

export interface EventPayload {
  type: MessageType.EVENT;
  eventName: string;
  detail: any;
}

export type APICallMessage = MessageEvent<APICallPayload>;
export function isApiCallMessage(msg: MessageEvent): msg is APICallMessage {
  return msg.data.type === MessageType.API_CALL;
}

export type APIResponseMessage = MessageEvent<APIResponsePayload>;
export function isAPIResponseMessage(
  msg: MessageEvent
): msg is APIResponseMessage {
  return msg.data.type === MessageType.API_RESPONSE;
}

export type StatusMessage = MessageEvent<StatusPayload>;
export function isStatusMessage(msg: MessageEvent): msg is StatusMessage {
  return msg.data.type === MessageType.STATUS;
}

export type EventMessage = MessageEvent<EventPayload>;
export function isEventMessage(msg: MessageEvent): msg is EventMessage {
  return msg.data.type === MessageType.EVENT;
}

export function isApiResult(
  result: any
): result is supernova.external.ApiResult {
  return typeof result?.ok === "boolean";
}
